<template>
    <div>
        <v-chart :options="options"/>
    </div>
</template>
<style>
.echarts {
  width: 300px;
  height: 300px;
}
</style>
<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'

import 'echarts/theme/dark'

export default {
    name : "cmpgraficodoughnut",
    components: {
        'v-chart': ECharts
    },
    props:[		
        'rotulo',
        'legendas',
		'dados'
    ],
    data () {
        return {
            options : {
                color: [
						'#6610f2',  // Indigo
						'#593196',  // Purple
						'#8a5ff2',  // Indigo mais claro
						'#4c0a9c',  // Indigo mais escuro
						'#7a53b3',  // Purple mais claro
						'#4e318a',  // Purple mais escuro
						'#f26135',  // Laranja
						'#40c057',  // Verde
						'#ffc107',  // Amarelo
						'#333333',  // Cinza escuro
						'#cccccc'   // Cinza claro
					],
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b}: {c} ({d}%)'
                },
                legend: {
                    orient: 'vertical',
                    left: -5,
                    top: '30',
                    data: [],
                    textStyle: {
						fontSize: 8
					}
                },
                series: [
                    {
                        name: '',
                        type: 'pie',
                        radius: ['35%', '65%'],
                        avoidLabelOverlap: false,
                        label: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: '14',
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: []
                    }
                ]
            }
        }
    },
    mounted: function () {         
    },    
    computed:{
    },
    watch:{
        legendas(){
            this.options.legend.data    			= this.legendas;
            this.options.series[0].name 			= this.rotulo;
			this.options.series[0].data 			= this.dados; 
        }
    }    
}
</script>